// wishlist object regiset in windows
window.wishlist = {};

// share wishlist button modal init
window.wishlist.shareWishlist = () => {
  let shareWishBtn = document.querySelector('.share-btn'),
    wishlistCloseBtn = document.querySelector('.close-wishlist-popup'),
    wishlistModal = document.querySelector('.wishlist-popup');
  shareWishBtn.addEventListener('click', () => {
    wishlistModal.classList.add('active');
  })
  wishlistCloseBtn.addEventListener('click', () => {
    wishlistModal.classList.remove('active');
  })
}
async function triggerAjaxCart() {
  // Fetch the updated cart content
  const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

  // Dispatch the 'cart:change' event to trigger the AJAX cart update
  document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
    bubbles: true,
    detail: {
      baseEvent: "variant:add", // Adjust this based on your context
      cart: cartContent
    }
  }));
   document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent
        }
      }));
  document.dispatchEvent(new CustomEvent("cart:refresh"));
}
 
    const getLists = () =>{
      return new Promise((resolve)=>{
        _swat.fetchLists({
          callbackFn:function(getlists){
            console.log(getlists); 
            resolve(getlists);
          },
          errorFn:function(xhrObj) {
            // something went wrong
            console.log(xhrObj);
          }
        });
      });
    } 


    let loaded = document.querySelector('.loader');
    function swymCustomBlockZoneCallback() {
      executeJqueryFunctions();
      _swat.fetch((products) => { 
          console.log(products, 'products');
          if (products.length > 0) {

            let countEle = `<div class="count-wrapper"><span>${products.length} item(s)</span></div>`;
            document.querySelector('.wishlist-page__wrapper .grid-uniform').insertAdjacentHTML('beforebegin',countEle);
            // console.log(loaded.classList);
            loaded.classList.add('loaded');
            $(".wishlist-sort__wrapper").css("display", 'block');
            $(".wishlist-sort__wrapper").css("text-align", 'end');
            $(".wishlist-action-wrapper").html(`<br><a href="#" class="link">Delete Wishlist</a>`);
            setTimeout(() => {
              loaded.remove();  
            }, 150);
            products.forEach((product) => {
              const params = {empi: product.empi ,du: product.du ,epi: product.epi }
              _swat.getProductDetails(
                params,
                function(res) {
                  // console.log("Entire product json:", res);
                  generateProductCard(res, product);
                },
                function(e) {
                  console.log(e);
                }
              );
            });
            let auth = JSON.parse(localStorage.getItem("swym-authn"))['all'];
            if (__st.cid && auth['authn']) {
              shareWishlist(auth['regn']['userinfo']);
            }else{
              $(".wishlists__wrapper .login-wrapper p").text("Don’t lose your saved items.");
              $(".wishlists__wrapper .login-wrapper br").remove();
              $(".wishlists__wrapper .login-wrapper .wishlist-btn").attr("class",'');
              $(".wishlists__wrapper .login-wrapper a").first().addClass("link");
              $(".wishlists__wrapper .login-wrapper a").first().css('margin-right','2rem');
            } 
          } else {
            loaded.classList.add('loaded');
            setTimeout(() => {
              loaded.remove();  
            }, 150);
            let emtyState = `<p>You have no items in your wishlist.</p>
            <a class="wishlist-btn btn-primary" href="/collections/bestsellers">START SHOPPING</a>`;
            document.querySelector('.shop-all-wrapper').innerHTML = emtyState;
            $('.shop-all-wrapper').css('display', 'block');
          }
        });
    }
  
    /* Create a share functionality */
    const shareWishlist = (user) =>{
      let fullname = user.fname+' '+user.lname;
      let shareBtn = `<button class='share-btn wishlist-btn btn-primary'>Share Wishlist</button>`;
      document.querySelector(".wishlist-action-wrapper").insertAdjacentHTML('afterbegin',shareBtn);
      document.querySelector('.form-group input#sender-name').value=fullname;
      window.wishlist.shareWishlist();
    }

    // Via Mail 
    document.querySelector('.wishlist-popup-button button').addEventListener('click',()=>{
      let validator = {
        'sender-name':'please enter a sender name',
        'receiver-email':'please enter a receiver mail address'
      },
      errorMsg = [];

      let formfields = document.querySelectorAll('form.wishlist-popup-form input');
      formfields.forEach((ele)=>{
        if (ele.value.length == 0 ) {
          errorMsg.push(`<p class="info-alert-red">${validator[ele.getAttribute('id')]}<p/>`);
        }
      });
      if (errorMsg.length != 0) {
        $(".wishlist-form-info .error-msg").html(errorMsg);
      } else {
        $(".wishlist-form-info").hide();
        let option = {
          toEmailId: document.querySelector("input#receiver-email").value,
          fromName: document.querySelector('.form-group input#sender-name').value,
          note: document.querySelector('#note').value
        };
        _swat.sendListViaEmail(option,function(response){
          console.log("Send Mail Sucess",response); 
          $(".wishlist-popup").removeClass("active"),
          $(".wishlist-popup-form input#receiver-email").val(''),
          $(".wishlist-popup-form textarea.wishlist-note").val('');
        },function(error){
          console.log(error)
        });
        
      }
    });

    // Generate sharable link 
    document.querySelector("button.copy-link").addEventListener("click",()=>{
      _swat.generateSharedListURL(
        null,
        function(data, sharedListId) { 
          const el = document.createElement('input');
          el.value = data;
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
          $(this).parent()
          $('button.copy-link').children('.copy-text-click').addClass('btn-hide');
          $('button.copy-link').children('.copied-text-click').removeClass('btn-hide');
          setTimeout(() => {
            $('button.copy-link').children('.copy-text-click').removeClass('btn-hide');
            $('button.copy-link').children('.copied-text-click').addClass('btn-hide');
          }, 3000);
        },     // returns the generated url
        function(data) { console.log(data); }
      );
    });

    // Facebook Share
    document.querySelector("button.share-fb").addEventListener("click",()=>{
      let user = JSON.parse(localStorage.getItem("swym-authn"))['all']['regn']['userinfo'];
      let fullname = user.fname+' '+user.lname;
      let fbLink = _swat.retailerSettings.Wishlist.SharingModes[0]['url']
      _swat.shareListSocial(
        null,
        fullname,
        fbLink,
        "facebook",
        function(data) { console.log(data) }
      ); 
    });

    // Twitter Share
    document.querySelector("button.share-tw").addEventListener("click",()=>{
      let user = JSON.parse(localStorage.getItem("swym-authn"))['all']['regn']['userinfo'];
      let fullname = user.fname+' '+user.lname;
      let fbLink = _swat.retailerSettings.Wishlist.SharingModes[1]['url']
      _swat.shareListSocial(
        null,
        fullname,
        fbLink,
        "twitter",
        function(data) { console.log(data) }
      ); 
    });

    /* Create a Product Card */
    const generateProductCard = (product, wishlistProduct) => {
      let variant = product.variants.filter(variant => variant.id == wishlistProduct.epi )[0];
      let cartBtn = '';
      if (variant.available) {
        cartBtn = `
        <button class="cart-btn  add-to-cart" data-prodId="${ wishlistProduct.empi }" data-varId="${wishlistProduct.epi }" data-url="${wishlistProduct.du}">
          Add to Cart
        </button>`;
      }
      
      else {    
    cartBtn = `
      <button class="cart-btn add-to-cart" disabled>
        Sold Out
      </button>`;
  }
      
      let trashIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 12.9">
      <path d="M6.6 12.4c.2.2.6.2.8 0l4.8-4.8c1-1 1.5-2.3 1.5-3.5 0-2.3-1.6-3.8-3.8-3.8-.9-.1-1.9.3-2.6 1l-.3.4-.4-.4C5.2-.2 2.7-.2 1.3 1.3.6 2.1.2 3.1.2 4.1c0 1.4.6 2.7 1.5 3.5l4.9 4.8z" fill-rule="evenodd" clip-rule="evenodd" fill="#fff"></path>
      <path d="M3.9 1.2c.7 0 1.4.3 1.9.8l.8.8c.2.2.6.2.8-.1l.8-.7C9.3.9 11 .9 12 2c.5.5.8 1.2.8 1.9 0 1.1-.4 2.1-1.2 2.9L7 11.4 2.4 6.8C1.6 6 1.2 5 1.2 3.9c0-1.5 1.2-2.7 2.7-2.7zm2.7 11.5c.2.2.6.2.8 0l5-5c1-1 1.6-2.3 1.6-3.7 0-2.3-1.7-4-3.9-4-1 0-2 .4-2.7 1.1l-.4.4-.4-.4c-1.5-1.5-4-1.5-5.5 0C.4 1.9 0 2.9 0 3.9c0 1.4.6 2.8 1.6 3.7l5 5.1z" fill-rule="evenodd" clip-rule="evenodd"></path>
    </svg>`;
      let html = `
      <div class="product-item-wrapper">
        <div class="product-content">
          <a href="/products/${product.handle}" class="image-container" tabindex="-1">
            <img src="${variant.featured_image != null ? variant.featured_image.src : product.images[0] }" alt="${variant.featured_image != null ? variant.featured_image.alt : product.images[0]}" />
          </a>
          <div class="product-info">
            <a class="p-title" href="/products/${product.handle}" title="${product.title}">${ product.title }</a>
            <div class="price-and-atc-btns">
              <div class="product-prices">
                <div class="price">
                  <span class="money"> ${ formatMoney(variant.price , themeVariables.settings.moneyFormat) }</span>
                </div>
                <div class="compare_at_price">
                  <del class="money">${ variant.compare_at_price != null && variant.compare_at_price > variant.price ?  formatMoney(variant.compare_at_price,themeVariables.settings.moneyFormat) : ''}
                  </del>
                </div>
              </div> 
              <div class="product-act">
                <button class="wishlist-close" data-prodId="${ wishlistProduct.empi }" data-varId="${wishlistProduct.epi }" data-url="${wishlistProduct.du}" data-image="${wishlistProduct.iu}" data-price="${wishlistProduct.pr}">${trashIcon} <span style="display:none;">Remove Wishlist</span></button>
              </div>
            </div>
            ${cartBtn}
          </div>
        </div>
      </div>`;
      document.querySelector("#wishlists_product .products").insertAdjacentHTML("beforeend",html);
    }
  
    const executeJqueryFunctions = () =>{
      // Remove wishlist Button JS
      $(document).on("click",".wishlist-close",(evt)=>{
        // $(evt.target).attr('fill','#ffffff');
        let prodId = evt.currentTarget.getAttribute('data-prodId');
        let varId = evt.currentTarget.getAttribute('data-varId');
        let prodURL = evt.currentTarget.getAttribute('data-url');
        let prodImg = evt.currentTarget.getAttribute('data-image');
        let prodPrice = evt.currentTarget.getAttribute('data-price');
        $(evt.currentTarget).find('svg path').first().css('fill','#FFF');
        _swat.removeFromWishList(
          {
            "epi": varId,
            "du": prodURL,
            "empi": prodId,
            "iu" : prodImg,
            "pr": prodPrice
          },
          function(res) {
            // console.log(res);
            // console.log('Removed to wishlist');
            _swat.fetch((products) => {
              if(products.length == 0){
                 if (!__st.cid) {
                  let notLoggedIn = `
                  <div class="login-wrapper">
                    <p>Looking for your saved items?</p>
                    <a class="wishlist-btn btn-primary" href="/account/login">SIGN IN</a>
                    <br>
                    <a href="/account/register" class="link">CREATE AN ACCOUNT</a>
                  </div>`;
                  $(".wishlist-page__wrapper .login-wrapper").replaceWith(notLoggedIn);
                }
                let emtyState = `<p>You have no items in your wishlist.</p>
                  <a class="wishlist-btn btn-primary" href="/collections/bestsellers">START SHOPPING</a>`;
                document.querySelector('.shop-all-wrapper').innerHTML = emtyState;
                $(".wishlist-action-wrapper").hide();
                document.querySelector('.count-wrapper').remove();
              } else {
                let checkCountHtml = document.querySelector('.count-wrapper span');
                if (checkCountHtml) {
                  checkCountHtml.innerHTML = `${products.length} item(s)`;
                } else {
                  let countEle = `<div class="count-wrapper"><span>${products.length} item(s)</span></div>`;
                  document.querySelector('.wishlist-page__wrapper .grid-uniform').insertAdjacentHTML('beforebegin',countEle);
                }
              }
            });
            $(evt.currentTarget).parents(".product-item-wrapper").remove();
          }
        );
      });

      // Delete all wishlists items
      $(document).on("click",".wishlist-action-wrapper a.link", async function(evt){
        let lists = await getLists();
        lists.forEach((list)=>{
          _swat.deleteList(list.lid, function(deletedListObj){
            console.log("Deleted list with listid", deletedListObj.lid);
          }, function(xhrObject) {
            // something went wrong
          });
        });
        window.location.reload();
      });

      // Add to Cart Button 
      $(document).on("click",".add-to-cart",(evt)=>{
        let prodId = evt.currentTarget.getAttribute('data-prodId');
        let varId = evt.currentTarget.getAttribute('data-varId');
        let prodURL = evt.currentTarget.getAttribute('data-url');
         $(evt.currentTarget).text("Adding...");
         _swat.replayAddToCart(
          {empi:prodId, du:prodURL},
          varId,
          function(res){
            evt.currentTarget.classList.add("added-in-cart");
            $(evt.currentTarget).text("Added To Cart");
            console.log("successfully added in cart !",res);
             triggerAjaxCart();
          },
          function(error){
            console.log(error);
          }
        );
      });
    }
    /* Money Formating  */
    const formatMoney = (cents, format) => {
      if (typeof cents == 'string') { cents = cents.replace('.',''); }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || this.money_format);
  
      function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
      }
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');
  
        if (isNaN(number) || number == null) { return 0; }
  
        number = (number/100.0).toFixed(precision);
  
        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';
  
        return dollars + cents;
      }
  
      switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    };
// }); 


    if (!window.SwymCallbacks) window.SwymCallbacks = [];
    window.SwymCallbacks.push(swymCustomBlockZoneCallback);